export const WHACK_A_MONKEY_ADDRESS = '0x5fEeD9189781b25eA4Cd9B9EdF3756F183D81aDb'; 